const GCLID_KEY = "gclid";
const GCLID_TS_KEY = "gclid_ts";
const EXPIRATION_MS = 30 * 24 * 60 * 60 * 1000;

function setGclidCookie(value) {
    const expires = new Date();
    expires.setDate(expires.getDate() + 30);
    document.cookie =
        `${GCLID_KEY}=${encodeURIComponent(value)}` +
        `;expires=${expires.toUTCString()}` +
        `;path=/;SameSite=Lax`;
}

function getGclidFromCookie() {
    const match = document.cookie.match(
        new RegExp(`(?:^|;\\s*)${GCLID_KEY}=([^;]*)`)
    );
    return match ? decodeURIComponent(match[1]) : null;
}

function getGclidFromLocalStorage() {
    const value = localStorage.getItem(GCLID_KEY);
    const ts = localStorage.getItem(GCLID_TS_KEY);
    if (!value || !ts) return null;
    if (Date.now() - Number(ts) > EXPIRATION_MS) {
        localStorage.removeItem(GCLID_KEY);
        localStorage.removeItem(GCLID_TS_KEY);
        return null;
    }
    return value;
}

export function getGclidFromUrlOrStorage() {
    if (typeof window === 'undefined') return "";
    const urlGclid = new URLSearchParams(window.location.search).get(GCLID_KEY);
    if (urlGclid) return urlGclid;
    return getGclidFromCookie() || getGclidFromLocalStorage() || "";
}

export function initGclidTracking() {
    if (typeof window === 'undefined') return;
    const gclid = new URLSearchParams(window.location.search).get(GCLID_KEY);
    if (!gclid) return;
    setGclidCookie(gclid);
    localStorage.setItem(GCLID_KEY, gclid);
    localStorage.setItem(GCLID_TS_KEY, String(Date.now()));
}

const PAID_SIGNAL_KEYS = ["gclid", "gbraid", "wbraid", "gad_source"];

/**
 * Detecta sinais de tráfego pago do Google Ads na URL atual.
 * Serve apenas como gatilho de classificação (attributionUtils.js) — não gera
 * persistência própria para gbraid/wbraid/gad_source, diferente do gclid.
 */
export function getGoogleAdsSignal(searchParams) {
    const isPaid = PAID_SIGNAL_KEYS.some((key) => searchParams.has(key));
    const campaignId = searchParams.get("gad_campaignid");
    return { isPaid, campaignId: campaignId || null };
}
